import type { Plan, PlanFunction, Struct } from "#public"
import type { TaskDescriptor } from "#public"
import type { TaskMap } from "#public"

import { PlanHash } from "../../internal/PlanHash"

const Node = (
  descriptor: TaskDescriptor,
  name: string,
  data: Record<string, unknown>,
  inputs: PlanFunction<unknown>[]
): PlanFunction<unknown> => ({
  name,
  data: data as Struct,
  inputs,
  inputIO: descriptor[name].input,
  outputIO: descriptor[name].output,
  // a `hash` prop is the caller's identity for the data when it already
  // has one: hashing `data` walks all of it, which is the whole cost for
  // a payload that embeds files or other plans (Literal, Array)
  hash: PlanHash(name, data.hash ?? data, ...inputs.map(input => input.hash)),
})

// a task whose props are an empty record is called with its inputs alone
export const CreatePlan = <TM extends TaskMap>(descriptor: TaskDescriptor): Plan<TM> =>
  new Proxy({} as Plan<TM>, {
    get: (_, name: string) =>
      descriptor[name].props
        ? (data: Record<string, unknown>, ...inputs: PlanFunction<unknown>[]) =>
            Node(descriptor, name, data, inputs)
        : (...inputs: PlanFunction<unknown>[]) => Node(descriptor, name, {}, inputs),
  })
